const DEFAULT_AUTH_ERROR_MESSAGE = "Unable to authenticate user";
export const POLICY_MANAGER_BROKER_ACCESS_MESSAGE =
	"Error Logging In. Access not authorized. Please contact your broker to make any modifications to your policy.";

export function formatAuthErrorMessage(message, fallback = DEFAULT_AUTH_ERROR_MESSAGE) {
	const normalizedMessage = typeof message === "string" ? message.trim() : "";
	const normalizedFallback = typeof fallback === "string" && fallback.trim() ? fallback.trim() : DEFAULT_AUTH_ERROR_MESSAGE;

	if (!normalizedMessage) return normalizedFallback;

	return normalizedMessage.replace(/^Error:\s*/i, "");
}

export function getAuthErrorMessage({ response, data } = {}, fallback = DEFAULT_AUTH_ERROR_MESSAGE) {
	return formatAuthErrorMessage(data?.message || response?.message, fallback);
}

export function isPolicyManagerBrokerAccessMessage(message) {
	return formatAuthErrorMessage(message, "").toLowerCase() === POLICY_MANAGER_BROKER_ACCESS_MESSAGE.toLowerCase();
}
